// imports
import { styled, Button } from '@mui/material';
import { LINK_BLUE } from '../../constants/colors';

/**
 * PrimaryButton
 *
 * This is the styling for the all caps blue buttons that are used for "UPDATE MAP", etc.
 *
 */
export const PrimaryButton = styled(Button)({
  backgroundColor: LINK_BLUE,
  color: 'white',
  lineHeight: '2rem',
  padding: '0.5rem 1.125rem 0.375rem',
  fontWeight: 400,
  textTransform: 'uppercase',
  letterSpacing: '1px',
  fontFamily: '"Segoe UI", sans-serif',
  border: 'none',
  '&:hover': {
    backgroundColor: '#162E51',
  },
  '&.MuiButton-root': {
    minWidth: 'unset',
  },
  '&.Mui-disabled': {
    backgroundColor: '#c4c4c4',
    color: 'white',
  },
});
